(ns ui.components.highlight-text.view
  "A text with the parts that a search found marked. See
   `common.opensearch.highlight` for the rules."
  (:require
   [common.opensearch.highlight :as highlight]))

(def ^:private mark-class
  "tw2-rounded-sm tw2-bg-alert-warning-bg tw2-text-inherit")

(defn text-parts
  "The parts of `text` for the search `words`. `marked` is the same value with the
   marks of OpenSearch, or nil. Its marks show a typo, which the words cannot find."
  [{:keys [text words marked]}]
  (let [{marked-text :text marked-ranges :ranges} (when (string? marked)
                                                     (highlight/marked->ranges marked))
        text (if (= marked-text (str text))
               marked-text
               (str text))
        ranges (concat (highlight/word-ranges text words)
                       (when (= marked-text text)
                         marked-ranges))]
    (highlight/parts text ranges)))

(defn view
  "`text` with the parts that the search `words` found marked. `marked` is the value
   that OpenSearch marked, see `text-parts`. With no search, the text stays as it is."
  [{:keys [text words marked] :as props}]
  (if (and (empty? words)
           (nil? marked))
    [:<> (str (or text ""))]
    (into [:<>]
          (map-indexed (fn [index {part-text :text match? :match?}]
                         (if match?
                           ^{:key index} [:mark {:class mark-class} part-text]
                           ^{:key index} [:<> part-text])))
          (text-parts props))))
